import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AssetField } from '../state-man/models/asset-field.model';

@Injectable({
  providedIn: 'root'
})
export class AssetFieldService {

  constructor(
    private apiService: ApiService
  ) { }
  
  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: AssetField[] | null } | null> {      
    try {
      const ret = await this.apiService.getVersionedList('assets/fields/', version)
      return ret && { version: ret.version, rows: ret.rows && AssetField.buildMany(ret.rows) }
    } 
    catch (error) {      
      return null
    }
  }  
}
